module.exports = __webpack_public_path__ + "img/ИФ-1(А)-012-m.17ee3bec.png";